import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { CTAButton } from "./ui";

export const FinalCTA = () => {
  const { t } = useLang();
  const c = t.finalCta;
  return (
    <section data-testid="final-cta-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="relative overflow-hidden rounded-[2.5rem] brand-gradient-deep px-6 py-20 md:py-28 text-center shadow-[0_40px_100px_-30px_rgba(124,58,237,0.5)]">
          <div className="absolute inset-0 grain-overlay opacity-[0.06] pointer-events-none" />
          <div className="absolute -top-24 -left-16 h-80 w-80 rounded-full bg-gold-500/20 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-white/10 blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl mx-auto">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-3xl sm:text-4xl lg:text-6xl font-bold text-white leading-[1.1] text-balance"
            >
              {c.title}
              <span className="block italic text-gold-300">{c.accent}</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.15, duration: 0.7 }}
              className="mt-7 text-lg md:text-xl text-white/80 leading-relaxed max-w-2xl mx-auto"
            >
              {c.sub}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.7 }}
              className="mt-10"
            >
              <CTAButton href="#contact" data-testid="final-cta-button" className="text-lg px-9 py-4">
                {c.cta} <ArrowRight size={20} />
              </CTAButton>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
